import { Link, useParams } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { CircularProgress } from "@mui/material"
import { sageJobSiteService } from "../../../services/sageJobSiteService"
import { useSiteTerminology } from "../../../contexts/PublicSiteContext"
import JobSiteDailyHours, {
  JobSiteBackLink,
} from "../../../components/jobSites/JobSiteDailyHours"
import { JobSiteSecondaryPanels } from "../../../components/jobSites/JobSiteSecondaryPanels"

export default function JobSiteDetail() {
  const { id } = useParams()
  const jobSiteId = Number(id)
  const { locationsLabel, areaSingular } = useSiteTerminology()

  const { data: listResponse, isLoading: listLoading } = useQuery(
    ["sage-job-sites"],
    () => sageJobSiteService.getAll(),
    { enabled: Number.isFinite(jobSiteId) && jobSiteId > 0, suspense: true }
  )

  const jobSite = listResponse?.data?.find((site) => site.id === jobSiteId)

  if (!jobSiteId) return null

  if (listLoading && !listResponse) {
    return (
      <div className="w-full flex justify-center items-center h-64">
        <CircularProgress />
      </div>
    )
  }

  if (!jobSite) {
    return (
      <div className="flex flex-col items-center justify-center p-8">
        <h2 className="text-2xl font-bold mb-4">{areaSingular} not found</h2>
        <Link to="/app/locations" className="px-4 py-2 bg-primary text-white rounded-lg">
          Return to {locationsLabel}
        </Link>
      </div>
    )
  }

  return (
    <div className="w-full min-h-full overflow-auto h-full p-2 md:p-4 bg-secondary-extra-light">
      <JobSiteBackLink />
      <JobSiteDailyHours jobSite={jobSite} />
      <JobSiteSecondaryPanels jobSite={jobSite} />
    </div>
  )
}
